import React from "react";
import "./SearchPage.css";
import Response from "../data/response";
import { Link, useParams } from "react-router-dom";
import searchPage__logo from "../assets/googlelogo_color_272x92dp.png";
import Search from "./Search";
import SearchIcon from "@material-ui/icons/Search";
import DescriptionIcon from "@material-ui/icons/Description";
import ImageIcon from "@material-ui/icons/Image";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import RoomIcon from "@material-ui/icons/Room";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useGoogleSearch from "../hooks/useGoogleSearch";
import { useEffect } from "react";
import { useState } from "react";

function SearchPage() {
  const { q } = useParams();
  const [term, setTerm] = useState("");

  // LIVE API CALL
  const { data } = useGoogleSearch(q);

  // MOCK API CALL
  // const data = Response;

  useEffect(() => {
    if (q !== undefined && q !== "undefined" && q !== null) {
      setTerm(q);
    }
  }, [q]);

  return (
    <div className="searchPage">
      <header className="searchPage__header">
        <Link to="/">
          <img className="searchPage__logo" src={searchPage__logo} alt="" />
        </Link>
        <div className="searchPage__headerBody">
          <Search hideButtons />
          <div className="searchPage__options">
            <div className="searchPage__optionsLeft">
              <div className="searchPage__option">
                <SearchIcon />
                <Link to={window.location}>All</Link>
              </div>
              <div className="searchPage__option">
                <DescriptionIcon />
                <Link to={window.location}>News</Link>
              </div>
              <div className="searchPage__option">
                <ImageIcon />
                <Link to={`/images/${q || term}`}>Images</Link>
              </div>
              <div className="searchPage__option">
                <LocalOfferIcon />
                <Link to={window.location}>Shopping</Link>
              </div>
              <div className="searchPage__option">
                <RoomIcon />
                <Link to={window.location}>Maps</Link>
              </div>
              <div className="searchPage__option">
                <MoreVertIcon />
                <Link to={window.location}>More</Link>
              </div>
            </div>
            <div className="searchPage__optionsRight">
              <div className="searchPage__option">
                <Link to={window.location}>Settings</Link>
              </div>
              <div className="searchPage__option">
                <Link to={window.location}>Tools</Link>
              </div>
            </div>
          </div>
        </div>
      </header>
      {q && (
        <main className="searchPage__results">
          <p className="searchPage__resultCount">
            About {data?.searchInformation.formattedTotalResults} results (
            {data?.searchInformation.formattedSearchTime} seconds) for {q}
          </p>
          {data?.items.map((item) => (
            <div className="searchPage__result">
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.displayLink}
              </a>
              <a
                className="searchPage__resultTitle"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <h2>{item.title}</h2>
              </a>
              <p className="searchPage__resultSnippet">{item.snippet}</p>
            </div>
          ))}
        </main>
      )}
    </div>
  );
}

export default SearchPage;
